let handler = null;

export function registerOdooLoginHandler(next) {
  handler = next;
}

export function notifyOdooLogin(payload) {
  return handler?.(payload);
}
